import { render, staticRenderFns } from "./newList.vue?vue&type=template&id=494faf11&scoped=true&"
import script from "./newList.vue?vue&type=script&lang=js&"
export * from "./newList.vue?vue&type=script&lang=js&"
import style0 from "./newList.vue?vue&type=style&index=0&id=494faf11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494faf11",
  null
  
)

export default component.exports